import { Currency, CurrencyDirection } from "@types";

type FormatConfig = {
  pattern: CurrencyPattern;
  symbol: string;
  direction: CurrencyDirection;
};

export enum CurrencyPattern {
  AMOUNT_CURRENCY = "{{amount}} {{currency}}",
  CURRENCY_AMOUNT = "{{currency}} {{amount}}",
}

export const CURRENCY_CONFIGS: Record<Currency, FormatConfig> = {
  THB: {
    pattern: CurrencyPattern.AMOUNT_CURRENCY,
    symbol: "฿",
    direction: CurrencyDirection.SUFFIX,
  },
  PHP: {
    pattern: CurrencyPattern.CURRENCY_AMOUNT,
    symbol: "P",
    direction: CurrencyDirection.PREFIX,
  },
  IDR: {
    pattern: CurrencyPattern.CURRENCY_AMOUNT,
    symbol: "Rp",
    direction: CurrencyDirection.PREFIX,
  },
  BDT: {
    pattern: CurrencyPattern.CURRENCY_AMOUNT,
    symbol: "৳",
    direction: CurrencyDirection.PREFIX,
  },
  PKR: {
    pattern: CurrencyPattern.CURRENCY_AMOUNT,
    symbol: "Rs",
    direction: CurrencyDirection.PREFIX,
  },
  INR: {
    pattern: CurrencyPattern.CURRENCY_AMOUNT,
    symbol: "₹",
    direction: CurrencyDirection.PREFIX,
  },
  MXN: {
    pattern: CurrencyPattern.CURRENCY_AMOUNT,
    symbol: "$",
    direction: CurrencyDirection.PREFIX,
  },
  BRL: {
    pattern: CurrencyPattern.CURRENCY_AMOUNT,
    symbol: "R$",
    direction: CurrencyDirection.PREFIX,
  },
  PEN: {
    pattern: CurrencyPattern.CURRENCY_AMOUNT,
    symbol: "S/",
    direction: CurrencyDirection.PREFIX,
  },
};
